import RelatedArticlesComponent from "../../../../components/help/RelatedArticlesComponent.tsx";
import QuestionAnswerComponent, {Question} from "../../../../components/help/QuestionAnswerComponent.tsx";
import {imageMap} from "../../../../images/imageMap.ts";
import {Link} from "react-router-dom";
import Icon from "../../../../components/selfcare/Icon.tsx";
import Routing from "../../../../Routing.ts";
import IconOpenInNew from "../../../../components/icons/IconOpenInNew.tsx";
import IconDownload from "../../../../components/icons/IconDownload.tsx";

const questions: Question[] = [
    {
        question: "Første regning",
        answer: <>
            <div className="article article--connect">
                <div className="paragraph">
                    <h3>Som Hiper-kunde betaler du altid en måned forud</h3>
                    <p>
                        Når den første regning er betalt, betaler du månedsvis forud, så du d. 1. i hver måned får en regning for den efterfølgende måned.
                        Du betaler med det betalingskort, du har registreret i Mit Hiper.
                    </p>
                    <ul className="list list--bullet">
                        <p>
                            <strong>Den første regning indeholder flere perioder:</strong>
                        </p>
                        <li><p>
                            Perioden fra den dato, dit internet aktiveres og resten af måneden ud.
                        </p></li>
                        <li><p>
                            Den efterfølgende måned.
                        </p></li>
                        <p>
                            Første regning indeholder også betaling for evt. oprettelse, forsendelse af udstyr og teknikerbesøg.
                        </p>
                    </ul>
                </div>
                <img
                    className="paragraph-image"
                    src={imageMap.help.subscription.first_invoice}
                    alt="Grafik der illustrerer regningsperioderne for første regning."
                />
            </div>
            <div className="article article--connect">
                <div className="paragraph">
                    <h3>Hvornår modtager jeg min regning?</h3>
                    <p>
                        Du modtager din første regning på mail tidligst 14 dage før din onlinedato.
                    </p>
                </div>
            </div>
            <div className="article article--connect">
                <div className="paragraph">
                    <h3>Hvornår skal jeg betale min første regning?</h3>
                    <p>
                        Du betaler den første regning 5 dage efter, du har modtaget den.
                        Er dit internet klar inden for 9 dage, fra du bestiller, trækker vi pengene kort efter din forbindelse er blevet oprettet.
                        Du betaler inden internettet er klar, da vi har omkostninger ved at oprette din forbindelse og sende udstyret til dig.
                        Vi tager derfor en betaling, som hjælper os til at holde prisen for selve bredbåndsforbindelsen på et minimum.
                    </p>
                </div>
            </div>
            <div className="article article--connect">
                <div className="paragraph">
                    <h3>
                        Min online dato er blevet rykket og jeg har allerede betalt min regning &ndash; hvad gør jeg?
                    </h3>
                    <p>
                        Din næste regning bliver automatisk tilrettet, hvis din online dato rykkes.
                        Dvs. hvis du har betalt for meget, så vil pengene blive modregnet din næste regning.
                        Regningen vil altid blive tilpasset til de dage, hvor du har internet og er online på din forbindelse.
                    </p>
                </div>
            </div>
        </>
    },
    {
        question: "Anden regning",
        answer: <>
            <div className="article article--connect">
                <div className="paragraph">
                    <h3>Hvorfor skal jeg allerede betale igen, når jeg lige har betalt?</h3>
                    <p>
                        På første regning betaler du for din 1. og 2. måned.
                        Anden regning modtager du d. 1. i den efterfølgende måned, og den indeholder den kommende måned.
                    </p>
                    <p>
                        <strong>Eksempel:</strong><br/>
                        Hvis dit internet er klar d. 27. januar, dækker din første regning d. 27.-31. januar og hele februar.
                        Du modtager anden regning d. 1. februar, som dækker for marts &ndash; du betaler nemlig en måned forud.
                    </p>
                </div>
                <img
                    className="paragraph-image no-br"
                    src={imageMap.help.subscription.second_invoice}
                    alt="Grafik der illustrerer regningsperioderne i det brugte eksempel for anden regning."
                />
            </div>
        </>
    },
    {
        question: "Min regning er ikke som forventet",
        answer: <>
            <div className="article article--connect">
                <div className="paragraph">
                    <h3>Har du fået en ny hastighed?</h3>
                    <p>
                        Hvis du ændrer din hastighed og det påvirker din abonnementspris, bliver din regning automatisk tilrettet på efterfølgende regning.
                    </p>
                </div>
            </div>
            <div className="article article--connect">
                <div className="paragraph">
                    <h3>Kampagnepris</h3>
                    <p>
                        Kampagnen gælder fra din online dato og x måneder frem.
                        Hvis din kampagne f.eks. udløber midt februar, vil du blive opkrævet normal abonnementspris for den sidste halvdel af februar på den regning, du betaler d. 1. januar.
                        Så når din kampagnepris udløber, bliver du opkrævet forud for den normale abonnementspris.
                    </p>
                    <p>
                        Mere information om præcise perioder, prisændringer mm. findes i de individuelle regninger i <Link to={Routing.Selfcare.Bills}>Mit Hiper</Link>.
                    </p>
                </div>
                <img
                    className="paragraph-image no-br"
                    src={imageMap.help.subscription.campaign_end_invoice}
                    alt="Grafik der illustrerer regningsperioderne for når en kampagne slutter."
                />
            </div>
            <div className="article article--connect">
                <div className="paragraph">
                    <h3>Kreditnota</h3>
                    <p>
                        Hvis du modtager en kreditnota, har du et tilgodehavende hos os &ndash; det er ikke en regning, du skal betale.
                    </p>
                    <p>
                        Dit tilgodehavende bliver modregnet din næste regning.
                    </p>
                    <p>
                        Hvis du har opsagt dit abonnement, får du udbetalt dit tilgodehavende, så snart vi modtager dit udstyr retur.
                        Hvis du modtager en kreditnota, skal du ikke foretage dig noget.
                    </p>
                    <p>
                        Modtager du en kreditnota, kan du se den <Link to={Routing.Selfcare.Bills}>her i Mit Hiper</Link>.
                    </p>
                </div>
            </div>
            <div className="article article--connect">
                <div className="paragraph">
                    <h3>Hvor kan jeg se mine regninger?</h3>
                    <p>
                        Du kan se alle dine regninger på <Link to={Routing.Selfcare.Bills}>Mit Hiper</Link>.
                    </p>
                    <p>
                        På Mit Hiper kan du få et overblik over alle dine regninger, fremtidige betalinger og dit tilgodehavende.
                    </p>
                    <p>
                        Du kan se en regning eller kreditnota ved at trykke på knappen <Icon
                        component={IconOpenInNew}
                        className={"icon-inline"}
                    /> og downloade den ved at trykke på knappen <Icon
                        component={IconDownload}
                        className={"icon-inline"}
                    /> Så kan du se perioden og prisen på hver enkelt regning.
                    </p>
                    <ul className="list list--bullet">
                        <p>
                            På Mit Hiper kan du bl.a. se:
                        </p>
                        <li><p>
                            Alle dine regninger
                        </p></li>
                        <li><p>
                            Dit tilgodehavende
                        </p></li>
                        <li><p>
                            Hvornår vi trækker din næste regning
                        </p></li>
                    </ul>
                </div>
                <img
                    className="paragraph-image box-shadow"
                    src={imageMap.help.subscription.invoice_first}
                    alt="Grafik der illustrerer regninger vist i Mit Hiper."
                />
            </div>
            <div className="article">
                <div className="paragraph">
                    <h3>Har du ikke en bruger på Mit Hiper?</h3>
                    <p>
                        Du kan oprette en bruger ved at indtaste din email-adresse <Link to={Routing.Selfcare.LoginCreate}>her</Link>.
                        Så får du en mail med et link til at oprette en ny bruger.
                    </p>
                </div>
            </div>
        </>
    }
];

export default function ForstaaRegningArticle() {
    return (
        <>
            <article className="help-article-content">
                <div className="article">
                    <div className="text-box text-box--gray">
                        <p>
                            Har du svært ved at forstå din regning?
                            Vi har samlet en del forklaringer, som hjælper dig med at forstå, hvad din regning indeholder og hvad du præcis betaler for.
                        </p>
                    </div>
                </div>

                <div className="article">
                    <QuestionAnswerComponent questions={questions}/>
                </div>
            </article>

            <RelatedArticlesComponent
                articles={[
                    {
                        "category": "regning-og-betaling",
                        "article": "betalingsmuligheder",
                        "name": "Betalingsmuligheder"
                    },
                    {
                        "category": "mit-abonnement",
                        "article": "mit-hiper",
                        "name": "Mit Hiper"
                    }
                ]}
            />
        </>
    )
}
